var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2072_2607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20539 16.9207L5.23075 20.5592L1.66846 20.6346C0.603859 18.66 0 16.4008 0 14C0 11.6785 0.564594 9.4892 1.56538 7.56152H1.56614L4.73758 8.14296L6.12686 11.2954C5.83609 12.1431 5.6776 13.0531 5.6776 14C5.67771 15.0277 5.86387 16.0123 6.20539 16.9207Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7552 11.3846C27.916 12.2315 27.9998 13.1061 27.9998 14C27.9998 15.0023 27.8945 15.98 27.6937 16.9231C27.0122 20.1323 25.2314 22.9346 22.7645 24.9177L22.7637 24.9169L18.7691 24.7131L18.2038 21.1838C19.8407 20.2239 21.1199 18.7215 21.7938 16.9231H14.3076V11.3846H21.903H27.7552Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7633 24.9169L22.7641 24.9177C20.3649 26.8462 17.3172 28 13.9995 28C8.66797 28 4.0326 25.02 1.66797 20.6346L6.2049 16.9208C7.38719 20.0762 10.431 22.3223 13.9995 22.3223C15.5333 22.3223 16.9703 21.9077 18.2033 21.1839L22.7633 24.9169Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9362 3.22306L18.4008 6.93613C17.1247 6.13845 15.6162 5.67766 14.0001 5.67766C10.3508 5.67766 7.25003 8.02687 6.12697 11.2954L1.5662 7.56153H1.56543C3.89545 3.06923 8.58927 0 14.0001 0C17.397 0 20.5116 1.21002 22.9362 3.22306Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2072_2607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelogo);
export default __webpack_public_path__ + "static/media/googlelogo.21636985f9f50bb3d71a76595db8b453.svg";
export { ForwardRef as ReactComponent };